// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel';
import type { PjpMetricQueryModelType } from './PjpMetricQuery';

export type ReferenceLineTypeEnum = 'ABSOLUTE';

export type ReferenceLineModelType = {
    type: ReferenceLineTypeEnum,
    value: number,
    label: ?string,
    alwaysShow: boolean
};

export type PjpMetricGraphModelType = {
    id: string,
    description: ?string,
    includeExistingBeat: ?boolean,
    graphQueries: Array<Object>,
    statisticQueries: Array<number>,
    refLines: ?Array<ReferenceLineModelType>,
    queries: Array<PjpMetricQueryModelType>
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class PjpMetricGraph extends ImmutableModel {
    static fromJS(json: PjpMetricGraphModelType): PjpMetricGraph {
        const state: Object = Object.assign({}, json);
        state.graphQueries = Immutable.List(state.graphQueries);
        state.statisticQueries = Immutable.List(state.statisticQueries);
        state.refLines = state.refLines
            ? Immutable.List(state.refLines).map(item =>
                  ReferenceLine.fromJS(item)
              )
            : state.refLines;
        state.queries = Immutable.List(state.queries).map(item =>
            PjpMetricQuery.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): PjpMetricGraphModelType {
        return {
            id: this.id,
            description: this.description,
            includeExistingBeat: this.includeExistingBeat,
            graphQueries: this.graphQueries.toArray(),
            statisticQueries: this.statisticQueries.toArray(),
            refLines: this.refLines
                ? this.refLines.toArray().map(item => item.toJS())
                : this.refLines,
            queries: this.queries.toArray().map(item => item.toJS())
        };
    }

    get id(): string {
        return this._state.get('id');
    }

    setId(id: string): this {
        return this.clone(this._state.set('id', id));
    }

    get description(): ?string {
        return this._state.get('description');
    }

    setDescription(description: ?string): this {
        return this.clone(this._state.set('description', description));
    }

    get includeExistingBeat(): ?boolean {
        return this._state.get('includeExistingBeat');
    }

    setIncludeExistingBeat(includeExistingBeat: ?boolean): this {
        return this.clone(
            this._state.set('includeExistingBeat', includeExistingBeat)
        );
    }

    get graphQueries(): Immutable.List<Object> {
        return this._state.get('graphQueries');
    }

    setGraphQueries(graphQueries: Immutable.List<Object>): this {
        return this.clone(this._state.set('graphQueries', graphQueries));
    }

    get statisticQueries(): Immutable.List<number> {
        return this._state.get('statisticQueries');
    }

    setStatisticQueries(statisticQueries: Immutable.List<number>): this {
        return this.clone(
            this._state.set('statisticQueries', statisticQueries)
        );
    }

    get refLines(): ?Immutable.List<ReferenceLine> {
        return this._state.get('refLines');
    }

    setRefLines(refLines: ?Immutable.List<ReferenceLine>): this {
        return this.clone(this._state.set('refLines', refLines));
    }

    get queries(): Immutable.List<PjpMetricQuery> {
        return this._state.get('queries');
    }

    setQueries(queries: Immutable.List<PjpMetricQuery>): this {
        return this.clone(this._state.set('queries', queries));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class ReferenceLine extends ImmutableModel {
    static fromJS(json: ReferenceLineModelType): ReferenceLine {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): ReferenceLineModelType {
        return {
            type: this.type,
            value: this.value,
            label: this.label,
            alwaysShow: this.alwaysShow
        };
    }

    get type(): ReferenceLineTypeEnum {
        return this._state.get('type');
    }

    setType(type: ReferenceLineTypeEnum): this {
        return this.clone(this._state.set('type', type));
    }

    get value(): number {
        return this._state.get('value');
    }

    setValue(value: number): this {
        return this.clone(this._state.set('value', value));
    }

    get label(): ?string {
        return this._state.get('label');
    }

    setLabel(label: ?string): this {
        return this.clone(this._state.set('label', label));
    }

    get alwaysShow(): boolean {
        return this._state.get('alwaysShow');
    }

    setAlwaysShow(alwaysShow: boolean): this {
        return this.clone(this._state.set('alwaysShow', alwaysShow));
    }
}
